import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const sendWidgetConversationsMessage = async (selectedDomain: string, conversationId: number, content: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `widget/sendFromShop`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            cid: conversationId,
            content,
        },
        isEncrypted: true,
    });
}